export const VPS_HOSTING_PAGE_SLUG = 'vps-hosting';
